import { useState } from 'react'
import { kuiperClassNames, Conditional } from '@opallabs/kuiper'
import { Popover, Icon } from '@opallabs/lapidary'
import { track } from '@opallabs/quanta'
import ApprovalsPopoverContent from './ApprovalsPopoverContent'

type ItemListHeadingProps = {
  autostart: boolean
  id: string | number
  isFinalApproval: boolean
  locked: boolean
  postId: number
  renderMenu: boolean
  requires_all_approvals: boolean
  shouldRender: boolean
  theme: string
  title: string
  update: (args: {
    requires_all_approvals?: boolean
    autostart?: boolean
  }) => void
}

const ItemListHeading: React.FC<ItemListHeadingProps> = ({
  autostart,
  id,
  isFinalApproval,
  locked,
  postId,
  renderMenu,
  requires_all_approvals,
  shouldRender,
  theme,
  title,
  update,
}) => {
  const [popoverOpen, setPopoverOpen] = useState(false)

  const onChangeApprovalsNeeded = (requiresAllApprovals: boolean): void => {
    track('Approvals: Phase Requirements', {
      contentId: postId,
      phaseId: id,
      allRequired: requiresAllApprovals,
    })

    update({ requires_all_approvals: requiresAllApprovals })
  }

  const onChangePhaseStart = (autostart: boolean): void => {
    track('Approvals: Phase Start Mode', {
      contentId: postId,
      phaseId: id,
      autostart,
    })

    update({ autostart })
  }

  return (
    <Conditional condition={shouldRender}>
      <div className={kuiperClassNames('item-group-header', `theme-${theme}`)}>
        <div className={kuiperClassNames('item-group-title')}>
          <div
            className={kuiperClassNames('item-group-title-text', {
              'is-popover-open': popoverOpen,
            })}
          >
            {title}

            <Conditional condition={renderMenu}>
              <Popover.Root open={popoverOpen} onOpenChange={setPopoverOpen}>
                <Popover.Trigger>
                  <div className={kuiperClassNames('item-group-button')}>
                    <Icon
                      glyph="gem-settings"
                      width={12}
                      height={12}
                      ariaLabel="Change phase settings"
                    />
                  </div>
                </Popover.Trigger>
                <Popover.Content style={{ zIndex: 9999 }}>
                  <ApprovalsPopoverContent
                    autostart={autostart}
                    onChangeApprovalsNeeded={onChangeApprovalsNeeded}
                    onChangePhaseStart={onChangePhaseStart}
                    onDoneClick={() => setPopoverOpen(false)}
                    locked={locked}
                    requiresAllApprovals={requires_all_approvals}
                  />
                </Popover.Content>
              </Popover.Root>
            </Conditional>
          </div>
          <Conditional condition={isFinalApproval}>
            <div
              className={kuiperClassNames('item-group-title-final-approval')}
            >
              Final
            </div>
          </Conditional>
        </div>
      </div>
    </Conditional>
  )
}

export default ItemListHeading
